/**
 * @file ZIP file detection for Uppy file routing (multipart vs XHR).
 */

import type { UppyFile } from '@uppy/core';

import { isZipUploadFile } from './create-s3-multipart-plugin';

type Meta = Record<string, unknown>;
type Body = Record<string, unknown>;

/**
 * Whether a Uppy file should use S3 multipart upload (ZIP by name or MIME).
 * @param file - Uppy file from upload manager instance.
 */
export const isZipUppyFile = (file: UppyFile<Meta, Body>) => {
  if (file.data instanceof File) {
    return isZipUploadFile(file.data);
  }

  const name = file.name ?? '';
  const type = file.type ?? '';
  return (
    name.toLowerCase().endsWith('.zip') ||
    type === 'application/zip' ||
    type === 'application/x-zip-compressed'
  );
};
